import React,{useEffect,useState} from 'react'
import classes from '../css/SubscribePage.module.css'
import { Link, useNavigate } from 'react-router-dom'
import { v4 as uuidv4 } from "uuid";
import { baseUrlApi, getscriptflow } from '../api/api';
import axios from 'axios';
import { toast } from "react-toastify";



const ContentBlock = () => {
 const [extRef, setExtRef] = useState("");
     const [sourceTrxId,setSourceTrxId] = useState(null)
   const [loading, setLoading] = useState(false);
     const [TVal, setTVal] = useState("");
 
    const navigate = useNavigate()




    const uniqueId = uuidv4()
    
        const getScript = async () => {
        setLoading(true);
      
        try {
          const url = `${baseUrlApi}${getscriptflow}?txnId=${uniqueId}`;
          const { data } = await axios.get(url);
          console.log(data,'---data---')
         
      
          const parsed = JSON.parse(data.response); 
          const scriptContent = parsed.s;
          const t = parsed.t;
          const ti = data.ti;
      
          console.log(t,'--t----');
          console.log(ti,'=======ti=======');
          console.log(scriptContent,'=====sc======')
      
          //  keep them for the backend wherever you like
          // sessionStorage.setItem("antiScript", scriptContent);
          // sessionStorage.setItem("antiToken", t);
          // sessionStorage.setItem("antiTxnId", ti);
      
          // also in state if you still need them here
          setTVal(t);
          setExtRef(ti);
      
          //  inject the returned anti‑fraud script (unchanged)
          if (scriptContent) {
            const top_head = document.head;
            const anti_script = document.createElement("script");
            anti_script.innerHTML = scriptContent;
            top_head.insertBefore(anti_script, top_head.firstChild);
      
            document.dispatchEvent(new Event("DCBProtectRun"));
            document.addEventListener("gateway-load", (evt) => {
              console.log("Anti‑fraud gateway loaded:", evt);
            });
          }
        } catch (error) {
          console.error("Error fetching script‑flow:", error);
          toast.error("Could not load verification script.");
        } finally {
          setLoading(false);
        }
      };
    
      
          useEffect(()=>{
                //  getScript()
          },[])


          const handleDecline=()=>{
            // window.location.href = 'https://www.vodacom.co.za/vodacom/shopping/v/add-to-bill'
            navigate('/blank')
          }
    

  return (
    <>
        <div className={`cptpl_page ${classes.wrapper}`}>
   <input type="hidden" value="20221206" name="cptpl_template" class="cptpl_template"/>
   {/* <input type="hidden" value="20251023" name="cptpl_template" class="test cptpl_template" />  */}

      <input type="hidden" value="" name="cptpl_landing_page_id" class="test  cptpl_landing_page_id  " />

  <div className={classes.card}>
    <div className={classes.logoHeading}>
      <img src="https://vd-kickwin.gameit.in/assets/images/soccer-ball.png" alt="Logo" className={`cptpl_logo cptpl_logo_static  ${classes.logo}`}
     crossorigin="anonymous" />
      <h3 className={`cptpl_service ${classes.heading}`}>Kick n Winn</h3>
    </div>

    

     {/* <p className={classes.subtext}>
       
          Get Endless Sports Insights with Kick n Winn
          <span className="cptpl_price" > R9/Day</span><br />
          <span className="cptpl_account" >On Your Vodacom Account</span><br />
          <span className="cptpl_bill" >Pay with Vodacom Add To Bill</span>
          
        </p>
          <Link to='/terms' className={` cptpl_terms ${classes.terms}`}>Terms & Conditions</Link>
        <br/><br/> */}

    <div className={classes.block_content} >

    

    <p className={classes.subtext}>
{/* Content Services are currently blocked for this number. If you select 'ACCEPT' you will be allowed to purchase this specific content, but other content services will remain blocked. */}

Your request to Kick n winn Service has been rejected due to the Content Block set on your Vodacom number. Please contact your Vodacom Administrator.
 
     {/* This number is not eligible to purchase or subscribe to content services */}
    </p>

      {/* <div className={classes.btns}>
        <button type="submit" className={`protected cptpl_subscribe ${classes.subbutton}`} onClick={()=>navigate('/subscribe')}>
        ACCEPT
      </button>
      <button type="button" className={`protected cptpl_exit  ${classes.extbutton}`} onClick={handleDecline}>
        DECLINE
      </button>
      </div> */}
      </div>

    
  </div>
</div>

    </>
  )
}

export default ContentBlock
